<template>
  <div :class="$style.toast" :test-id="testId">
    <div :class="$style.row">
      <slot name="icon" />
      <div :class="$style.content">
        <div :class="$style.titleRow">
          <div :class="$style.title">{{ title }}</div>
          <button
            type="button"
            :class="$style.closeButton"
            :title="$t('common.action.close')"
            :aria-label="$t('common.action.close')"
            :test-id="`${testId}-close`"
            @click="emit('close')"
          >
            <SCASvgIcon icon="phosphor/x" size="16px" />
          </button>
        </div>
        <div v-if="subtitle" :class="$style.meta">
          <span>{{ subtitle }}</span>
          <span v-if="percentage !== undefined" :class="$style.percentage">{{ Math.round(percentage) }}%</span>
        </div>
      </div>
    </div>
    <SCAProgressBar v-if="percentage !== undefined" :value="percentage" appearance="inverted" />
  </div>
</template>

<script setup lang="ts">
import { SCAProgressBar, SCASvgIcon } from "@scayla/components";
import { useI18n } from "vue-i18n";

const { t: $t } = useI18n();

defineProps<{
  title: string;
  subtitle?: string;
  /** Omit to render no meta row / progress bar (a bare title + close button). */
  percentage?: number;
  testId: string;
}>();

const emit = defineEmits<{
  close: [];
}>();
</script>

<style lang="scss" module>
.toast {
  width: 320px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: var(--space-component-gap-small);
  padding: var(--space-component-padding-large);
  border-radius: var(--border-radius-large);
  background-color: var(--color-interaction-neutral-subtle-normal);
  color: var(--color-content-primary);
  box-shadow:
    0px 8px 16px -2px var(--color-coolGreyA-p3),
    0px 2px 2px -1px var(--color-coolGreyA-p6);
}
.row {
  display: flex;
  align-items: center;
  gap: var(--space-component-gap-large);
  width: 100%;
}
.content {
  display: flex;
  flex-direction: column;
  gap: var(--space-component-gap-xSmall);
  flex: 1;
  min-width: 0;
}
.titleRow {
  display: flex;
  align-items: center;
  gap: var(--space-component-gap-large);
}
.closeButton {
  all: unset;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: var(--size-2xSmall);
  height: var(--size-2xSmall);

  &:hover {
    opacity: 0.7;
  }
}
.title {
  @include Globals.typo-body-medium;
  color: inherit;
  flex: 1;
  min-width: 0;
}
.meta {
  display: flex;
  align-items: center;
  gap: var(--space-component-gap-small);
  @include Globals.typo-body-small;
  color: var(--color-content-secondary);

  .percentage {
    margin-left: auto;
  }
}
</style>
